<template>
    <ion-list>
        <page-header :title="$t('signup.title')" />
        <ion-grid>
            <ion-row>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        v-if="eyeColorOptions"
                        :options="eyeColorOptions"
                        :label="$t('options.eyeColor')"
                        type="eye-color"
                        @onChange="handleChange"
                        @onClear="handleClear"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        v-if="hairColorOptions"
                        :options="hairColorOptions"
                        :label="$t('options.hairColor')"
                        type="hair-color"
                        @onChange="handleChange"
                        @onClear="handleClear"
                    />
                </ion-col>
                <ion-col size-xs="12" size-sm="6" size-md="4">
                    <options-selector
                        v-if="skinColorOptions"
                        :options="skinColorOptions"
                        :label="$t('options.skinColor')"
                        type="skin-color"
                        @onChange="handleChange"
                        @onClear="handleClear"
                    />
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="6">
                    <options-selector
                        :options="heightOptions"
                        :label="$t('options.height')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="height"
                    />
                </ion-col>
                <ion-col size="6">
                    <options-selector
                        :options="weightOptions"
                        :label="$t('options.weight')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="weight"
                    />
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size-xs="12" size-sm="12" size-md="6">
                    <options-selector
                        :options="originCountryOptions"
                        :label="$t('options.originCountry')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="origin-country"
                    />
                </ion-col>

                <ion-col size-xs="12" size-sm="12" size-md="6">
                    <options-selector
                        :options="educationalLevelOptions"
                        :label="$t('options.educationalLevel')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="educational-level"
                    />
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size-xs="12" size-sm="12" size-md="6">
                    <options-selector
                        :options="jobOptions"
                        :label="$t('options.job')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="job"
                    />
                </ion-col>
            </ion-row>
            <ion-row v-if="user" class="contact-ways">
                <ion-col size-xs="12" size-sm="12" size-md="12">
                    <female-contact-ways
                        v-if="user.options.find(option => option.type === 'gender').value == 'female'"
                        :label="$t('options.contactWays')"
                        type="contact-ways"
                        :options="contactWaysOptions"
                        @onChange="handleContactWaysChange"
                    />
                    <checkbox-list
                        v-else
                        :label="$t('options.contactWays')"
                        type="contact-ways"
                        :options="contactWaysOptions"
                        @onChange="handleContactWaysChange"
                    />
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-button class="ion-float-end" @click="updateOptions" shape="round" strong>
            {{ $t('master.next') }}
            <img class="icon-next icon-img-xs" src="@/assets/icon-images/arrow-right-white.png" />
        </ion-button>
    </ion-list>
</template>

<script>
import OptionsSelector from '@/components/OptionsSelector'
import AxiosController from '@/controllers/AxiosController'
import FemaleContactWays from '@/components/FemaleContactWays'
import CheckboxList from '@/components/CheckboxList'
import PageHeader from '@/components/PageHeader'
import { mapGetters } from 'vuex'
import { isMobile } from 'mobile-device-detect'

export default {
    components: {
        OptionsSelector,
        FemaleContactWays,
        CheckboxList,
        PageHeader
    },
    name: 'RegisterTwo',
    computed: mapGetters(['user']),
    data() {
        return {
            originCountryOptions: [],
            hairColorOptions: [],
            eyeColorOptions: [],
            skinColorOptions: [],
            heightOptions: [],
            weightOptions: [],
            educationalLevelOptions: [],
            jobOptions: [],
            contactWaysOptions: [],
            selectedOptions: {},
            userGender: '',
            contactWaysDetails: {},
            isMobile
        }
    },
    mounted() {
        const params = {
            type: [
                'origin-country',
                'eye-color',
                'hair-color',
                'skin-color',
                'height',
                'weight',
                'educational-level',
                'job',
                'contact-ways'
            ]
        }
        AxiosController.get('/options', { params }).then(res => {
            this.originCountryOptions = res.data.filter(option => option.type === 'origin-country')
            this.eyeColorOptions = res.data.filter(option => option.type === 'eye-color')
            this.skinColorOptions = res.data.filter(option => option.type === 'skin-color')
            this.hairColorOptions = res.data.filter(option => option.type === 'hair-color')
            this.heightOptions = res.data.filter(option => option.type === 'height')
            this.weightOptions = res.data.filter(option => option.type === 'weight')
            this.educationalLevelOptions = res.data.filter(option => option.type === 'educational-level')
            this.jobOptions = res.data.filter(option => option.type === 'job')
            this.contactWaysOptions = res.data.filter(option => option.type === 'contact-ways')
        })
        this.userGender = this.user ? this.user.options.filter(option => option.type === 'gender')[0].value : 'male'
    },
    methods: {
        handleChange: function(option) {
            this.selectedOptions[option.type] = option.value
        },
        handleClear: function(option) {
            delete this.selectedOptions[option.type]
        },
        handleContactWaysChange: function(option) {
            if (this.userGender == 'male') {
                if (option.data.checked) {
                    this.selectedOptions[option.type + '-' + option.data.optionId] = option.data.optionId
                } else {
                    delete this.selectedOptions[option.type + '-' + option.data.optionId]
                }
            } else {
                if (option.data.data.length > 0) {
                    this.contactWaysDetails[option.data.optionId] = option.data.data
                } else {
                    delete this.contactWaysDetails[option.data.optionId]
                }
            }
        },
        updateOptions: function() {
            const data = {
                options: this.selectedOptions,
                details: this.contactWaysDetails
            }
            AxiosController.post('/auth/add-options', data).then(res => {
                this.$store.dispatch('setUser', res.data)
                this.$router.push('/register/step-3')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
ion-button {
    margin-top: 20px;
    --background: #7cc18b;
    --color: #000000;
}

#app[dir='rtl'] .icon-next {
    transform: rotate(180deg);
}

@media (min-width: 768px) {
    ion-col {
        margin-top: 7px;
    }

    .contact-ways {
        margin-top: 20px;
    }
    ion-button {
        margin: 30px;
    }
}
</style>
